






































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import { IMember } from '@/types/member'
import { getBoUrl } from '@/api/http-constants'
import orderBy from 'lodash/orderBy'
import uniqBy from 'lodash/uniqBy'
import Avatar from '@/components/Profil/Avatar.vue'

@Component({
    components: {
        Avatar,
    },
})
export default class Membres extends Vue {
    @Prop() private membres: IMember[]
    @Prop() private selectedMember: IMember
    @Prop() private classNames: string
    @Prop() private styleRules: string
    @Prop({ type: Boolean }) private selectable: boolean
    @Prop({ type: Boolean }) private clickable: boolean

    boUrl = getBoUrl()
    pSelectedMember: IMember = null

    get filteredMembers() {
        return uniqBy(this.membres, 'id')
    }

    get orderedMembers() {
        return orderBy(this.filteredMembers, ['owner', 'name'], ['desc', 'asc'])
    }

    @Watch('membres', { deep: true, immediate: true })
    onMembres() {
        if (this.pSelectedMember || !this.membres) {
            return
        }
        this.pSelectedMember = this.orderedMembers[0]
    }

    @Watch('selectedMember')
    onSelectedMember() {
        if (!this.selectedMember) {
            return
        }
        this.pSelectedMember = this.selectedMember
    }

    handleClick(membre: IMember) {
        this.pSelectedMember = membre
        this.$emit('click', membre)
    }

    mounted() {
        requestAnimationFrame(() => {
            ;(<any>$('.popover-dismiss')).popover({
                trigger: 'hover',
                container: 'body',
                boundary: 'window',
            })
        })
    }
}
